import { Map, List, fromJS } from 'immutable'

export function contacts(state = List(), action) {
  switch (action.type) {
    case 'CONTACTS_FETCH_SUCCESS':
      return fromJS(action.items || [])

    case 'CONTACT_CREATE_SUCCESS':
      let createdContact = fromJS(action.item || false)
      if (!Map.isMap(createdContact)) return state

      return state.push(createdContact)

    case 'CONTACT_EDIT_SUCCESS':
      let updatedContact = fromJS(action.item || false)
      if (!Map.isMap(updatedContact)) return state

      return state.map(t => (t.get('id') === updatedContact.get('id') ? updatedContact : t))

    case 'CONTACT_ATTACH_SUCCESS':
    case 'CONTACT_DEATTACH_SUCCESS':
      let attachContact = fromJS(action.item || false)
      if (!Map.isMap(attachContact)) return state

      let attachId = attachContact.get('id')

      let isFound = state.find(c => c.get('id') === attachId)

      if (isFound) return state.map(c => (c.get('id') === attachId ? attachContact : c))

      return state.push(attachContact)

    default:
      return state
  }
}

export function contactsLoading(state = false, action) {
  switch (action.type) {
    case 'CONTACTS_FETCH_LOADING':
      return action.loading || false
    default:
      return state
  }
}

export function contactsError(state = false, action) {
  switch (action.type) {
    case 'CONTACTS_FETCH_ERROR':
      return action.message || true
    default:
      return state
  }
}

export function rootContactCreating(state = false, action) {
  switch (action.type) {
    case 'ROOT_CREATE_CONTACT':
      return action.add || false
    case 'CONTACT_CREATE_SUCCESS':
      return false
    default:
      return state
  }
}

export function rootContactEditing(state = false, action) {
  switch (action.type) {
    case 'ROOT_EDIT_CONTACT':
      return action.id || false
    case 'CONTACT_EDIT_SUCCESS':
      return false
    default:
      return state
  }
}

export function cardContactCreating(state = false, { type } = {}) {
  if (type === 'CARD_CONTACT_CREATE') return true

  if (type === 'CONTACT_CREATE_SUCCESS') return false

  if (type === 'CONTACT_CREATE_CLOSE') return false

  return state
}

export function cardContactEditing(state = false, { type, id } = {}) {
  if (type === 'CARD_CONTACT_EDIT') return id

  if (type === 'CONTACT_EDIT_SUCCESS') return false

  return state
}

export function attachContactsLoading(state = false, action) {
  switch (action.type) {
    case 'CONTACT_ATTACH_LOADING':
      return action.loading || false
    case 'CONTACT_ATTACH_SUCCESS':
      return false
    default:
      return state
  }
}

export function attachContactsError(state = false, action) {
  switch (action.type) {
    case 'CONTACT_ATTACH_ERROR':
      return action.message || false
    default:
      return state
  }
}

export function deattachContactsLoading(state = false, action) {
  switch (action.type) {
    case 'CONTACT_DEATTACH_LOADING':
      return action.loading || false
    case 'CONTACT_DEATTACH_SUCCESS':
      return false
    default:
      return state
  }
}

export function deattachContactsError(state = false, action) {
  switch (action.type) {
    case 'CONTACT_DEATTACH_ERROR':
      return action.message || false
    default:
      return state
  }
}
